import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

import { setPreferredScanner } from "./scannerPreference";

/** Shown once per browser when more than one TWAIN device is online. */
export default function ScannerPickerDialog({ open, choices, onCancel, onSelect }) {
  const [selected, setSelected] = useState("");

  // Resets the selection when the connected device list changes between
  // scans. NOTE: micro-ui's equivalent component uses React's
  // adjust-state-during-render pattern instead, because that repo's
  // `react-hooks/set-state-in-effect` lint rule forbids this. pmswebapp is on
  // react-scripts 3.2 with no such rule, so the effect is fine here. The two
  // are deliberately different — do not "align" them.
  useEffect(() => {
    setSelected(choices[0] || "");
  }, [choices]);

  const handleConfirm = () => {
    if (!selected) return;
    setPreferredScanner(selected);
    onSelect(selected);
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Choose a scanner</DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{ marginBottom: "1rem" }}>
          More than one scanner is connected to this PC. Pick the one at this desk — we'll
          remember it for next time.
        </Typography>
        <RadioGroup value={selected} onChange={(e) => setSelected(e.target.value)}>
          {choices.map((choice) => (
            <FormControlLabel key={choice} value={choice} control={<Radio />} label={choice} />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="custom-button" onClick={handleConfirm} disabled={!selected}>
          Use this scanner
        </Button>
      </DialogActions>
    </Dialog>
  );
}
